import { SFConstants } from "../../../constants/SFConstants";
import { Poker2MailConfirmGiftDialog } from "../../../view/dialogs/mailverification/Poker2MailConfirmGiftDialog";
import { Poker2Command } from "../Poker2Command";

export class EMCCommand extends Poker2Command {
    protected get cmdId(): string {
        return "emc";
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            this.layoutManager.showDialog("Poker2MailConfirmGiftDialog");
            /*
            layoutManager.showDialog( "Poker2MailVerificationGiftDialog", new Poker2MailVerificationGiftDialogProperties(
                Poker2Model.languageData.getTextById("dialog_pesentreceived_title"),
                Poker2Model.languageData.getTextById("dialog_pesentreceived_text", [ 5000, 5 ]),
                "getGift"));
            */

        }
        return (error == 0);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
